import type React from "react";

import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import CustomButton from "~/component/common/CustomButton";

import useModal from "../../../../hooks/useModal";
import CreatePlaylistContent from "./CreatePlaylistContent";

const CreatePlaylistModalButton: React.FC = () => {
  const {openModal, closeModal, Modal} = useModal();

  return (
    <>
      <CustomButton
        onClick={openModal}
        aria-label="Create playlist"
        className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
      >
        <FontAwesomeIcon
          icon={faPlus}
          size="xl"
          className="text-white p-2 -m-2 rounded-full bg-gradient-to-br from-blue-600 via-blue-500 to-black"
        />
      </CustomButton>
      <Modal>
        <CreatePlaylistContent closeModal={closeModal} />
      </Modal>
    </>
  );
};

export default CreatePlaylistModalButton;
